<template>
  <div v-if="filteredBrandGroups.length" class="mb-3">
    <h1 :id="`b_${letter}`" class="text-uppercase mb-1">{{ letter }}</h1>
    <div class="row">
      <div
        v-for="(group, index) in filteredBrandGroups"
        :key="`brandGroup-${index}`"
        class="col-12 col-sm-8 col-md-6 col-lg-4"
      >
        <div v-for="brand in group" :key="brand.name">
          <a :href="brand.link" class="mb-1 text-sm text-dark d-block bd-Name">
            {{ brand.name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BrandListing",
  components: {},
  props: {
    entry: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      letter: this.entry[0],
      brands: this.entry[1],
      groupCount: 6,
    };
  },
  computed: {
    ...mapGetters({
      brandFilter: "brand/brandFilter",
    }),
    filteredBrandGroups() {
      const brands = this.brands.filter(brand => {
        return brand.name.toLowerCase().includes(this.brandFilter.toLowerCase());
      });
      return brands.inGroups(this.groupCount);
    },
  },
  mounted() {
    window.addEventListener("resize", this.setGroupCount);
    this.setGroupCount();
  },
  methods: {
    setGroupCount() {
      const width = document.body.clientWidth;
      this.groupCount = 6;
      if (width < 992) {
        this.groupCount = 4;
      }
      if (width < 768) {
        this.groupCount = 3;
      }
      if (width < 576) {
        this.groupCount = 2;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bd-Name {
  word-break: break-word;
}
</style>
